import styled from 'styled-components';
import { ellipsis, rem } from 'polished';
// import Checkbox from '../../../core/Checkbox';
import RadioButtonSmall from '../../../core/RadioButtonSmall';

/* Contenedor */
export const GroupSelectionWrap = styled.div`
  height: ${props => (props.size ? `${props.size}px` : 'auto')};
  max-height: ${props => (props.size ? `${props.size}px` : '314px')};
  overflow-x: hidden;
`;

/* Row-Header */
export const GroupSelectionHead = styled.section`
  background-color: ${props => props.theme.colors.main};
  color: ${props => props.theme.colors.light};

  display: flex;
  height: ${rem('36px')};
`;

/* Columna-Wide-Header */
export const GroupSelectionHeadDepartment = styled.div`
  color: ${props => props.theme.colors.light};
  font-family: ${props => props.theme.fonts.semiBold};
  padding-left: ${rem('20px')};
  min-width: ${props => (props.size ? `${props.size}px` : '300px')};
  ${ellipsis('300px')};
  text-align: left;
  margin: 0;
`;

/* Wrap de Cheackbox-Header & Body */
export const GroupSelection = styled.div`
  min-width: ${rem('76px')};
  width: ${rem('76px')};
`;

/* Textos-Header */
export const GroupSelectionTxt = styled.p`
  font-family: ${props => props.theme.fonts.semiBold};
  line-height: 2.5;
  margin: 0;
  text-align: center;
`;

/* Textos-Header-Izquierda */
export const GroupSelectionTxtLeft = GroupSelectionTxt.extend`
  text-align: left;
`;

/* Rows-Body */
export const GroupSelectionBody = styled.section`
  background-color: ${props =>
    props.selected
      ? props.theme.colors.secondaryLightest
      : props.theme.colors.grayLightest};
  display: flex;
  height: 40px;
  border-bottom: 1px solid
    ${props => (props.selected ? props.theme.colors.light : 'initial')};
  :nth-child(odd) {
    background-color: ${props =>
      props.selected
        ? props.theme.colors.secondaryLightest
        : props.theme.colors.grayLighter};
  }
`;

/* Capa para poder estilar el anidamiento de subdepartamentos */
export const GroupSelectionHeritage = styled.div`
  align-items: center;
  display: flex;
  height: 40px;
  justify-content: flex-start;
`;

/* Justificacióndel texto(data) */
export const GroupSelectionData = styled.p`
  margin-right: 15px;
  font-size: 0.875rem;
`;

/* Columna-Wide-Body */
export const GroupSelectionBodyDepartment = GroupSelectionHeadDepartment.extend`
  color: ${props => props.theme.colors.main};
  max-width: ${props => (props.size ? `${props.size}px` : '620px')};
  min-width: ${props => (props.size ? `${props.size}px` : '300px')};
  padding-left: ${props => `${(props.level + 1) * 20}px`};
`;

// Excepción en celda para hecer visible el tooltip
export const GroupSelectionBodyDepartmentCell = GroupSelectionBodyDepartment.extend`
  overflow: visible;
`;

/* MODAL SELECCIÓN GRUPO: Cell-Avatar-Header */
export const GroupCellAvatar = styled.span`
  align-items: center;
  display: flex;
  justify-content: center;
  width: ${rem('70px')};
`;

// Celda usuario dataUsers
export const DataUsers = styled.span`
  width: 35px;
`;
// Celda usuario ícono ojo
export const IconUsers = styled.span`
  width: 25px;
`;

/* Checkbox dentro de la tabla */
// export const StyledCheckbox = styled(Checkbox)`
// align-items: center;
// display: flex;
// justify-content: center;
// height: ${rem('40px')};
// `;
// Radio button dentro de la tabla
export const StyledRadioBody = styled(RadioButtonSmall)`
  align-items: center;
  align-self: center;
  display: flex;
  justify-content: center;
  height: ${rem('40px')};
  /*  box-shadow: none;
  height: 1rem;
  width: 1rem; */
`;

export const StyledWrapperAllNotifications = styled.div`
  position: relative;
`;

export const StyledDisabled = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  background: rgba(255, 255, 255, 0.5);
  width: 100%;
  height: 100%;
`;

// Altura de la tabla
// export const StyledTable = styled(Table)`
// max-height: 430px;
// `;
// // Celda usuario en listado Crear > Grupos
// export const StyledBodyRow = styled(Row)`
// box-sizing: border-box;
// height: 40px;
// `;
// // Celda usuario en listado Crear > Grupos - Avatar
// export const CellUsersImg = styled(Cell)`
// width: ${props => (props.size ? `${props.size}px` : 'auto')};
// `;
// // Celda usuario en listado Crear > Grupos - DataUsers
// export const CellUsersInfo = styled(Cell)`
// min-width: ${props => (props.size ? `${props.size}px` : 'auto')};
// `;
